import { render, staticRenderFns } from "./companyInfoBox.vue?vue&type=template&id=6ab36276&"
import script from "./companyInfoBox.vue?vue&type=script&lang=ts&"
export * from "./companyInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports